<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-input size="small" v-model="query.category_name" clearable maxlength="12" placeholder="类型名称"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-select size="small" v-model="query.type_id" filterable placeholder="类别类型" class="handle-select mr10"
					style="width: 180px;">
					<el-option v-for="item in typeList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="getData">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="showAdd">添加</el-button>
				
			</div>
			<el-table v-loading="loading" :data="tableData" border class="table m_t_20"
				header-cell-class-name="table-header" :row-style="{ height: '20px' }"
				:header-cell-style="{ 'text-align': 'center' }" :cell-style="{ padding: '6px' }" stripe>
				<el-table-column prop="categoryName" label="类型名称" align="center"></el-table-column>
				<el-table-column prop="typeId" label="类型" align="center">
					<template #default="scope">
						<span v-if="scope.row.typeId==1">关键字类型</span>
						<span v-if="scope.row.typeId==2">风险级别</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template #default="scope">
						
						<el-button size="small" type="primary" :class="[theme]"
							@click.stop="handleEdit(scope.row)">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="query.current"
					:page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="query.size" :total="pageTotal"
					@size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
			</div>
		</div>
		<el-dialog title="添加" v-model="addVisible" width="400px" @close="closeDialog" :close-on-click-modal="false">
			<el-form :model="addform" :rules="rules" ref="addform" label-width="100px">
				<el-form-item label="类型名称" prop="categoryName">
					<el-input size="small" v-model="addform.categoryName"></el-input>
				</el-form-item>
				<el-form-item label="类型类别" prop="typeId">
					<el-select size="small" v-model="addform.typeId" filterable clearable placeholder="类型类别"
						class="handle-select mr10" style="width: 100%;">
						<el-option v-for="item in typeList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getCategorySaves2">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="编辑" v-model="editVisible" width="400px" @close="closeDialog" :close-on-click-modal="false">
			<el-form :model="editform" :rules="rules" ref="editform" label-width="100px">
				<el-form-item label="类型名称" prop="categoryName">
					<el-input size="small" v-model="editform.categoryName"></el-input>
				</el-form-item>
				<el-form-item label="类型类别" prop="typeId">
					<el-select size="small" v-model="editform.typeId" filterable clearable placeholder="类型类别"
						class="handle-select mr10" style="width: 100%;">
						<el-option v-for="item in typeList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getCategorySaves">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="导入" v-model="importVisible" width="600px" @close="closeDialog" :close-on-click-modal="false">
			<el-form label-width="100px">
				<el-form-item label="上传文件">
					<el-upload ref="upload" action="/api/risk/keyword/import" :headers="token" :limit="1"
						:on-success="uploadSuccess" :auto-upload="false" :data="importForm" name="excelFile">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top:40px;">选择文件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	import { getKeywordTypeList, getCategoryDelete, getCategorySave, getKeywordImport } from '../api/inspection.js';
	export default {
		name: 'telephoneInspectionType',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					category_name: '',
					type_id: 1,
					current: 1,
					size: 10,
				},
				typeList: [{
						value: 1,
						label: '关键字类型'
					},
					{
						value: 2,
						label: '风险级别'
					}
				],
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
				pageTotal: 0,
				tableData: [],
				editVisible: false,
				editform: {
					categoryName: '',
					typeId: '',
					id: '',
				},
				addform: {
					categoryName: '',
					typeId: '',
					id: '',
				},
				importVisible: false,
				importForm: {},
				addVisible: false,
			};
		},
		created() {
			this.getData();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle(){
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			getData() {
				let data = {
					category_name: this.query.category_name,
					type_id: this.query.type_id,
					current: this.query.current,
					size: this.query.size,
				};
				this.loading = true;
				getKeywordTypeList(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.records;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleDelete(row) {
				// 二次确认删除
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							id: row.id
						};
						getCategoryDelete(data).then(res => {
							if (res?.code === 200) {
								this.$message.success(res.message);
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			showAdd() {
				this.addVisible = true;
			},
			handleEdit(row) {
				this.editform = row;
				this.editVisible = true;
			},
			closeDialog() {
				this.editVisible = false;
				this.importVisible = false;
				this.addVisible = false;
			},
			getCategorySaves2() {
				getCategorySave(this.addform).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.addVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getCategorySaves() {
				getCategorySave(this.editform).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.editVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getKeywordImports() {
				this.importVisible = true;
			},
			//导入
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadSuccess(success) {
				setTimeout(() => {
					this.$refs.upload.clearFiles();
				}, 2000);
				if (success?.code === 200) {
					this.importVisible = false;
					this.$message.success('上传成功');
					this.getData();
				} else {
					this.$message.error(success.message);
				}
			},
			// 分页导航
			handlePageChange(val) {
				this.query.current = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.query.current = 1; // 重置到第一页
				this.getData();
			},
		}
	};
</script>

<style scoped>
	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}
</style>